import { useLocation, useNavigate } from "react-router-dom";
import Layout from "../../components/layout/Layout";

export default function ViewProduct() {
  const location = useLocation();
  const data = location.state.data;
  const catgId = data?.categoryId?._id || "";

  const navigate=useNavigate();

  function formatDate(isoDateString) {
    const date = new Date(isoDateString); // Convert the ISO string to a Date object
    const day = date.getDate(); // Get the day of the month
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const month = monthNames[date.getMonth()]; // Get the short month name
    const year = date.getFullYear(); // Get the year
    return `${day}, ${month} ${year}`; // Format as "day, month year"
  }

  return (
    <div>
      <Layout>
        <div className="bg-white md:p-10 p-3 rounded-xl shadow-md mt-8">
          <div className="flex justify-between items-center">
            <h2 className="text-xl font-medium">View Product</h2>

            <button
              onClick={() => navigate(-1)}
              className="px-4 py-2 bg-gray-200 rounded-md hover:bg-gray-300"
            >
              Back
            </button>

          </div>

          <div className="mt-10">
            <div className="my-6">
              <img
                src={`${process.env.REACT_APP_MEDIA_BASE_URL}/${data.image}`}
                className="h-[100px] w-[100px] rounded-full border-2"
                alt=""
              />
            </div>
          </div>

          <div className="mt-10">
            <div className="flex my-6">
              <div className="w-1/2">
                <h6 className="text-sm font-medium">Category</h6>
                <p className="mt-1">{data?.categoryId?.name}</p>
              </div>
              <div className="w-1/2">
                <h6 className="text-sm font-medium">Product Name</h6>
                <p className="mt-1">{data?.name}</p>
              </div>
            </div>
            <hr />

            <div className="flex my-6">
              <div className="w-1/2">
                <h6 className="text-sm font-medium">Title</h6>
                <p className="mt-1">{data?.title}</p>
              </div>
              <div className="w-1/2">
                <h6 className="text-sm font-medium">Price</h6>
                <p className="mt-1">{data?.price}</p>
              </div>
            </div>
            <hr />

            <div className="flex my-6">
              <div className="w-1/2">
                <h6 className="text-sm font-medium">Description</h6>
                <p className="mt-1">{data.description}</p>
              </div>
              {/* <div className="w-1/2">
                <h6 className="text-sm font-medium">Payment Method</h6>
                <p className="mt-1">{data.paymentMethod}</p>
              </div> */}
            </div>
            <hr />
            <div className="flex my-6">
              <div className="w-1/2">
                <h6 className="text-sm font-medium">Stock Quantity</h6>
                <p className="mt-1">{data.stockQuantity}</p>
              </div>
              <div className="w-1/2">
                <h6 className="text-sm font-medium">Status</h6>
                <p className="mt-1">{data.status}</p>
              </div>
            </div>

            <hr />
            <div className="flex my-6">
              <div className="w-1/2">
                <h6 className="text-sm font-medium">Discounted Price</h6>
                <p className="mt-1">{data.discountPrice}</p>
              </div>
              {catgId === "67deed42f56f3e22dc5b82e8" ? (
                <div className="w-1/2">
                  <h6 className="text-sm font-medium">Litres</h6>
                  <p className="mt-1">{data?.quantity}</p>
                </div>
              ) : (
                <div className="w-1/2">
                  <h6 className="text-sm font-medium">Created At</h6>
                  <p className="mt-1">{formatDate(data.createdAt)}</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </Layout>
    </div>
  );
}
